import "core-js/stable";
import "regenerator-runtime/runtime";
import {call, put} from "redux-saga/effects";
import * as api_types from "./reducer";
import {getTalents} from "./requests";

export function* getTalentsSaga() {
    try {
        const response = yield call(getTalents);
        if(response.status === 200){
            yield put({type: api_types.GET_TALENTS_SUCCESS, response});
        }else{
            yield put({type: api_types.GET_TALENTS_ERROR, response});
        }
    } catch (error) {
        yield put({type: api_types.GET_TALENTS_ERROR, error})
    }
}

